module.exports = __webpack_public_path__ + "img/restaurant_bodyimage01.0a37c80a.jpg";